import cn from "clsx";
import styles from "./CommonStyles.module.css";

type CaptionContainerProps = Readonly<{
  caption?: string;
  children: React.ReactNode;
  captionClassName?: string;
  captionStyle?: React.CSSProperties;
  className?: string;
}>;

export const CaptionContainer = ({
  caption,
  children,
  captionClassName,
  captionStyle,
  className,
}: CaptionContainerProps) => {
  return (
    <div className={cn(styles.captionContainer, className)}>
      {children}
      {caption && (
        <div className={cn(styles.captionWrapper, "caption", captionClassName)} style={captionStyle}>
          {caption}
        </div>
      )}
    </div>
  );
};
